import { action } from 'typesafe-actions'
import { DeliveryRatingActionTypes } from './types'

export const ratingValidate = (token: string) => action(DeliveryRatingActionTypes.RATING_VALIDATE, { token })
export const ratingValidateResponse = (isValid: boolean) => (
  action(DeliveryRatingActionTypes.RATING_VALIDATE_RESPONSE, { isValid })
)
export const ratingValidateFailed = () => action(DeliveryRatingActionTypes.RATING_VALIDATE_FAILED)

export const ratingCreate = (token: string, rating: number) => (
  action(DeliveryRatingActionTypes.RATING_CREATE, { token, rating })
)
export const ratingCreateResponse = (isSent: boolean) => (
  action(DeliveryRatingActionTypes.RATING_CREATE_RESPONSE, { isSent })
)
